export default __webpack_public_path__ + "static/media/picture.0502336a.svg";